import { render, staticRenderFns } from "./ExcBlockWithImageLayoutContainer.vue?vue&type=template&id=736ea3c6&scoped=true&"
import script from "./ExcBlockWithImageLayoutContainer.vue?vue&type=script&lang=js&"
export * from "./ExcBlockWithImageLayoutContainer.vue?vue&type=script&lang=js&"
import style0 from "./ExcBlockWithImageLayoutContainer.vue?vue&type=style&index=0&id=736ea3c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736ea3c6",
  null
  
)

export default component.exports